import { disabledFriday } from '@/configs/general.configs';
import moment from 'moment';
import store from '../store';
import { entityType } from './enums';

export function getEntityNameByType (type) {
	switch (type) {
	case entityType.doctor: return 'doctor';
	case entityType.center: return 'center';
	case entityType.pharmacy: return 'pharmacy';
	default: return null;
	}	
}

export function isTouchDevice() {
	return (
		window.matchMedia('(pointer: coarse)').matches ||
		('ontouchstart' in window) ||
		(navigator.maxTouchPoints > 0) ||
		(navigator.msMaxTouchPoints > 0)
	);
}

export function disableDates(date) {
	const d = moment(date).startOf('day');
	if (d.day() !== 5 && disabledFriday) return true;
	return store.state.vacations.some(v => d.isBetween(moment(v.fromDate).startOf('day'), moment(v.toDate).startOf('day'), 'day', '[]'));
};

// export const disableDates = (date) => {
// 	const currentDate = new Date(date);
// 	currentDate.setHours(0, 0, 0, 0);

// 	// أولاً: تحقق مما إذا كان اليوم هو الجمعة (إذا كان خيار تعطيل الجمعة مفعّلاً)
// 	const isFriday = disabledFriday && currentDate.getDay() === 5;

// 	// ثانياً: تحقق مما إذا كان اليوم يقع ضمن فترة عطلة
// 	let isVacation = false;
// 	if (enableVacations) {
// 		const vacations = store.state.vacations || [];
// 		for (const vacation of vacations) {
// 			if (!vacation.fromDate || !vacation.toDate) {
// 				continue;
// 			}

// 			const from = new Date(vacation.fromDate);
// 			from.setHours(0, 0, 0, 0);
// 			const to = new Date(vacation.toDate);
// 			to.setHours(0, 0, 0, 0);

// 			// التعامل مع `repeatType` الذي قد يكون غير معرّف
// 			const repeatType = vacation.repeatType === null || vacation.repeatType === undefined ? -1 : parseInt(vacation.repeatType, 10);

// 			let isMatch = false;
// 			// لا تقم بتطبيق قواعد التكرار على التواريخ التي تسبق بداية العطلة
// 			if (repeatType !== -1 && currentDate < from) {
// 				continue;
// 			}

// 			switch (repeatType) {
// 			case 0: // تكرار أسبوعي
// 			{
// 				const currentDay = currentDate.getDay();
// 				const fromDay = from.getDay();
// 				const toDay = to.getDay();
// 				if (fromDay <= toDay) {
// 					isMatch = currentDay >= fromDay && currentDay <= toDay;
// 				} else { // في حال كانت الفترة تتجاوز نهاية الأسبوع (مثل: الجمعة إلى الإثنين)
// 					isMatch = currentDay >= fromDay || currentDay <= toDay;
// 				}
// 				break;
// 			}
// 			case 1: // تكرار شهري
// 			{
// 				const currentDay = currentDate.getDate();
// 				const fromDay = from.getDate();
// 				const toDay = to.getDate();
// 				if (fromDay <= toDay) {
// 					isMatch = currentDay >= fromDay && currentDay <= toDay;
// 				} else { // في حال كانت الفترة تتجاوز نهاية الشهر (مثل: من يوم 25 إلى يوم 5)
// 					isMatch = currentDay >= fromDay || currentDay <= toDay;
// 				}
// 				break;
// 			}
// 			case 2: // تكرار سنوي
// 			{
// 				const currentMonth = currentDate.getMonth();
// 				const currentDay = currentDate.getDate();
// 				const fromMonth = from.getMonth();
// 				const fromDay = from.getDate();
// 				const toMonth = to.getMonth();
// 				const toDay = to.getDate();

// 				// تحويل التواريخ إلى أرقام للمقارنة (الشهر * 100 + اليوم)
// 				const currentOrdinal = currentMonth * 100 + currentDay;
// 				const fromOrdinal = fromMonth * 100 + fromDay;
// 				const toOrdinal = toMonth * 100 + toDay;

// 				if (fromOrdinal <= toOrdinal) { // الفترة لا تتجاوز نهاية العام
// 					isMatch = currentOrdinal >= fromOrdinal && currentOrdinal <= toOrdinal;
// 				} else { // الفترة تتجاوز نهاية العام (مثل: من ديسمبر إلى يناير)
// 					isMatch = currentOrdinal >= fromOrdinal || currentOrdinal <= toOrdinal;
// 				}
// 				break;
// 			}
// 			default: // عطلة غير متكررة
// 				isMatch = currentDate >= from && currentDate <= to;
// 				break;
// 			}

// 			if (isMatch) {
// 				isVacation = true;
// 				break; // تم العثور على تطابق، لا داعي لمواصلة البحث
// 			}
// 		}
// 	}

// 	// يتم تعطيل التاريخ إذا كان يوم جمعة أو يقع ضمن عطلة
// 	return isFriday || isVacation;
// };